export function dedupeArrows<T extends { startSquare: string; endSquare: string }>(arrows: T[]): T[] {
  const seen = new Set<string>();
  return arrows.filter(({ startSquare, endSquare }) => {
    const key = `${startSquare}-${endSquare}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
